import { render, staticRenderFns } from "./resellerForm.vue?vue&type=template&id=1716a45e"
import script from "./resellerForm.vue?vue&type=script&lang=js"
export * from "./resellerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports